module.exports = __webpack_public_path__ + "img/wiping-swipe-for-floors.abf1dd83.svg";